import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=75ff69a6&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=75ff69a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ff69a6",
  null
  
)

export default component.exports